import { Link as RemixLink } from '@remix-run/react';
import React from 'react';

type AnchorProps = Omit<
  React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>,
  'href' | 'ref'
>;

interface Props extends AnchorProps {
  children: React.ReactNode;
  to: string;
  // TODO(johnwchadwick): Investigate proper typing.

  event?: any;
  disabled?: boolean;
}

const Link = ({ children, to, ...props }: Props) => {
  const addedProps: Pick<Props, 'onClick'> = {};

  if (!props.onClick && props.event && props.event.event && props.event.properties) {
    addedProps.onClick = () => {
      //@ts-expect-error - analytics is a global variable
      globalThis.analytics &&
        //@ts-expect-error - analytics is a global variable
        globalThis.analytics.track(props.event.event, props.event.properties);
    };
  }

  if (/^(http|https|insomnia|insomniad):\/\//.test(to)) {
    return (
      <a href={to} {...addedProps} {...props}>
        {children}
      </a>
    );
  }
  return (
    <RemixLink to={to} {...addedProps} {...props}>
      {children}
    </RemixLink>
  );
};

export default Link;
